import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../services/lds-user.service';
import { WsChatService } from '../lds-websocket-module/ws-chat/ws-chat.service';
import { WsPacketService } from '../lds-websocket-module/ws-packet/ws-packet.service';

@Component({
    selector: 'ds-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {
  btnDisabled: boolean = false;
  feedbackSent: boolean = false;
  feedbackError: boolean = false;
  constructor(private user: LdsUserService, private wsPacketService: WsPacketService, private wsChatService: WsChatService) {
  }

  ngOnInit() {
    this.user.currentModule = 'Feedback'

  }

  submit(text: string) {
    const payload = [];
    this.btnDisabled = true;
    this.feedbackError = false;
    payload.push(this.wsPacketService.getPacket('user', 'supportMessage', {
      message: `DATA DASHBOARD - ${text}`,
    }))
    this.wsChatService.sendMsgAsyc({
      data: payload
      , next: (response) => {
        const success = response[0].items[0].success;
        if (success) {
          this.btnDisabled = false;
          this.feedbackSent = true;
        } else {
          this.feedbackError = true;
        }
      }})
  }

}
